import { AlertTriangle, CheckCircle2, Clock } from "lucide-react";

const StatoCucinaHero = ({ scaduti, inScadenza, onClick }) => {
  let bg, border, icon, title, subtitle, color;

  if (scaduti > 0) {
    bg = "bg-red-50";
    border = "border-red-200";
    color = "text-red-700";
    icon = <AlertTriangle className="h-6 w-6 text-red-600" strokeWidth={2.5} />;
    title = `${scaduti} prodott${scaduti === 1 ? "o scaduto" : "i scaduti"}`;
    subtitle = "Tocca per vedere quali";
  } else if (inScadenza > 0) {
    bg = "bg-amber-50";
    border = "border-amber-200";
    color = "text-amber-800";
    icon = <Clock className="h-6 w-6 text-amber-600" strokeWidth={2.5} />;
    title = `${inScadenza} in scadenza`;
    subtitle = "Prossimi 7 giorni";
  } else {
    bg = "bg-emerald-50";
    border = "border-emerald-200";
    color = "text-emerald-700";
    icon = <CheckCircle2 className="h-6 w-6 text-emerald-600" strokeWidth={2.5} />;
    title = "Tutto in regola";
    subtitle = "Nessun lotto in scadenza";
  }

  const Wrap = onClick && scaduti + inScadenza > 0 ? "button" : "div";

  return (
    <Wrap
      onClick={onClick && scaduti + inScadenza > 0 ? onClick : undefined}
      className={`w-full ${bg} ${border} border rounded-2xl p-4 flex items-center gap-4 transition-all ${onClick && scaduti + inScadenza > 0 ? "active:scale-[0.99] hover:opacity-90 text-left" : ""}`}
      data-testid="stato-cucina-hero"
    >
      <div className={`w-12 h-12 rounded-full ${bg} flex items-center justify-center flex-shrink-0`}>
        {icon}
      </div>
      <div className="flex-1 min-w-0">
        <p className={`text-base font-extrabold ${color} truncate`}>{title}</p>
        <p className="text-xs text-gray-600 mt-0.5">{subtitle}</p>
      </div>
    </Wrap>
  );
};

export default StatoCucinaHero;
